import { Injectable } from '@angular/core';
import {Http, RequestOptions} from "@angular/http";
import {MdSnackBar} from "@angular/material";

@Injectable()
export class EmailTrackerService {
  private headers: any;
  private options: any;
  emailTrackersArray = [];
  emailTrackers = {};

  emails = [];
  facilityNames = [];
  tags = [];
  cities = [];
  states = [];

  constructor(
    private http: Http,
    private snackBar: MdSnackBar
  ) {
    this.getAutocomplete().toPromise().then((data) => {
      this.emails = data.emails;
      this.facilityNames = data.facilityNames;
      this.tags = data.tags;
      this.cities = data.cities;
      this.states = data.states;
    })
  }

  getAutocomplete() {
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.get('https://pug.gl/api/autocomplete', this.options).map((res) => res.json());
  }

  getAllTrackers() {
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.get('https://pug.gl/api/email-tracker', this.options).map((res) => res.json());
  }

  generateShortUrl(url, emailId) {
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.post('https://pug.gl/api/shorten/', {
      "url": url,
      "emailId": emailId,
      "source": "admin.storagepug"
    }, this.options).map((res) => res.json());
  }

  makeNewEmailTrackers(et, notes) {
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.post('https://pug.gl/api/email-tracker',{
      "to": et.to,
      "from": et.from,
      "title": et.title,
      "name": et.name,
      "notes": notes,
      "status": et.status,
      "tags": et.tags,
      "facilityName": et.facilityName,
      "website": et.website,
      "city": et.city,
      "state": et.state
    }, this.options).map((res) => res.json());
  }

  updateTracker(emailId, et) {
    this.headers = new Headers({
      "Content-Type": "application/json",
      "Accept": "application/json",
    });
    this.options = new RequestOptions({headers: this.headers});
    return this.http.post('https://pug.gl/api/email-tracker/update',{
      "emailId": emailId,
      "emailTracker": et
    }, this.options).map((res) => res.json());
  }

  openSnackBar(message: string, action: string = 'Close') {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/email-tracker.service.ts